import { fetch, Method, getPaging } from 'core/api/fetch';

const BASE_URL = '/api/v1.1.1/experiencer/experience';

const ExperienceRoutes = {
    getList: (options, params) => `${BASE_URL}?${params}&${getPaging(options)}`,
    updateStatus: `${BASE_URL}status`,
    getById: (experienceId) => `${BASE_URL}/${experienceId}`,
    add: BASE_URL,
    addYoutubeVideos: (experienceId) => `${BASE_URL}/${experienceId}/youtube`,
    update: (experienceId) => `${BASE_URL}/${experienceId}`,
    putMedia: (experienceId) => `${BASE_URL}/${experienceId}/media`,
};

export const ExperienceServiceV2 = {
    getList: async (options) => {
        try {
            const params = new URLSearchParams();

            if (options?.name?.length > 0) {
                params.append('name', options.name);
            }

            if (Array.isArray(options?.status) && options?.status?.length > 0) {
                options.status.forEach(({ id }) => params.append('status', id));
            }

            if (Array.isArray(options?.moduses) && options?.moduses?.length > 0) {
                options.moduses.forEach(({ id }) => params.append('moduses', id));
            }

            const { longitude, latitude, radius } = options;
            if (longitude && latitude && radius) {
                params.append('longitude', longitude);
                params.append('latitude', latitude);
                params.append('radius', radius);
            }

            const { data } = await fetch(ExperienceRoutes.getList(options, params.toString()), {
                method: Method.GET,
                authenticated: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            return data;
        } catch (error) {
            throw error;
        }
    },
    updateStatus: async (experiences, status) => {
        try {
            const { data } = await fetch(ExperienceRoutes.updateStatus, {
                method: Method.PATCH,
                authenticated: true,
                data: { experiences, status },
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            return data;
        } catch (error) {
            throw error;
        }
    },
    getById: async (experienceId) => {
        try {
            const { data } = await fetch(ExperienceRoutes.getById(experienceId), {
                method: Method.GET,
                authenticated: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            return data;
        } catch (error) {
            throw error;
        }
    },
    add: async (experienceData) => {
        try {
            const { data } = await fetch(ExperienceRoutes.add, {
                method: Method.POST,
                authenticated: true,
                data: experienceData,
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            return data;
        } catch (error) {
            throw error;
        }
    },
    addYouTubeVideos: async (experienceId, videos = []) => {
        try {
            if (!Number.isInteger(experienceId) || experienceId <= 0 || !Array.isArray(videos) || videos?.length === 0) return;

            const result = await fetch(ExperienceRoutes.addYoutubeVideos(experienceId), {
                method: Method.POST,
                authenticated: true,
                data: { videos },
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            return result;
        } catch (error) {
            throw error;
        }
    },
    update: async (experienceId, experienceData) => {
        try {
            if (!Number.isInteger(experienceId) || experienceId <= 0) return;

            const { data } = await fetch(ExperienceRoutes.update(experienceId), {
                method: Method.PATCH,
                authenticated: true,
                data: { ...experienceData },
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            return data;
        } catch (error) {
            throw error;
        }
    },
    putMedia: async (experienceId, media = []) => {
        try {
            if (!Number.isInteger(experienceId) || experienceId <= 0) return;

            const imagesToAdd = media?.filter((m) => !Number.isInteger(m?.id) && !m?.isVideo)?.map((m) => m?.file);

            const formData = new FormData();

            for (const file of imagesToAdd) {
                formData.append('images', file);
            }

            const experienceMedia = JSON.stringify(media?.map(({ file, ...rest }) => ({ ...rest, filename: file?.name || null })));
            formData.append('media', experienceMedia);

            const { data } = await fetch(ExperienceRoutes.putMedia(experienceId), {
                method: Method.PUT,
                authenticated: true,
                data: formData,
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });

            return data;
        } catch (error) {
            throw error;
        }
    },
};
